import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_PL.json';
import audios from './ASTROLOGY_AUDIOS_PL.json';

export const ASTROLOGY_DATA_PL: ServiceData = {
  articles,
  audios,
};
